import { getPackDisplayString } from '@/utils/item';
import { IngredientSearchResultMetadataType } from '@/contexts/menu-info-context';
import {
  IngredientType,
  ManualIngredientMetadata,
} from './menu-item-search-types';
import { ItemListOption } from '@/contexts/item-context-types';
import { ListOption } from '@/components/list-item';
import { ListSection } from '@/components/recycler-list';
import { MenuItemSearch_IngredientFieldsFragment } from '@/types';
import { PackUnit } from '@/enums';

interface CreateListSectionsParams {
  catalogIngredients?: ItemListOption[];
  catalogResultsLabel?: string;
  manualIngredients?: ListOption<ManualIngredientMetadata>[];
  manualResultsLabel?: string;
}

const buildSections = (
  sections: ListSection<IngredientType>[],
  data: IngredientType[],
  key: string,
) => (data.length > 0 ? [...sections, { data, key }] : sections);

export const createListSections = ({
  catalogIngredients = [],
  catalogResultsLabel = '',
  manualIngredients = [],
  manualResultsLabel = '',
}: CreateListSectionsParams): ListSection<IngredientType>[] => {
  let sections: ListSection<IngredientType>[] = [];
  sections = buildSections(sections, catalogIngredients, catalogResultsLabel);
  if (manualIngredients) {
    sections = buildSections(sections, manualIngredients, manualResultsLabel);
  }

  return sections;
};

export const isManualIngredientViaMetadata = (
  option: IngredientSearchResultMetadataType,
): boolean => option && 'menuItemIngredientUUID' in option;

// Transform a fragment into a ListOption<ManualIngredientMetadata> object
export const transformFragmentIntoManualIngredient = (
  fragment: MenuItemSearch_IngredientFieldsFragment,
  currencyCode: string,
): ListOption<ManualIngredientMetadata> => ({
  metadata: {
    baseUnit: (fragment.pack.base_unit as PackUnit) || null,
    currencyCode,
    displayName: fragment.ingredient_name,
    menuItemIngredientUUID: fragment.uuid,
    packDisplayString: getPackDisplayString({
      maxUnitSize: fragment.pack.max_unit_size,
      minUnitSize: fragment.pack.min_unit_size,
      unit: fragment.pack.unit as PackUnit,
    }),
    packUnit: fragment.pack.unit as PackUnit,
    unitCount: fragment.pack.unit_count,
    unitPriceInMicros: fragment.cost_in_micros,
  },
  title: fragment.ingredient_name,
  value: fragment.uuid,
});
